export default "__VITE_ASSET__CGyUzv$4__"